import * as React from 'react';

import { Grid, Typography } from "@material-ui/core";
import { MarketCoverPrice } from "./cover-price/MarketCoverPrice";
import { MarketAveragePrice } from "./average-price/MarketAveragePrice";
import { MarketPriceAverageTicket } from "./average-ticket/MarketPriceAverageTicket";
import { MarketPriceCoupon } from "./coupon/MarketPriceCoupon";
import { MarketPriceAverageTicketEvolution } from "./average-ticket-evolution-30days/MarketPriceAverageTicketEvolution";

import './MarketPrice.scss';

// tslint:disable-next-line:no-empty-interface
export interface IMarketPriceProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketPriceState {
}

export class MarketPrice extends React.Component<IMarketPriceProps, IMarketPriceState> {
    constructor(props: IMarketPriceProps) {
        super(props);
    }

    public render() {
        return (
            <Grid container={true} spacing={16} className="MarketPrice" >
                <Grid item={true} xs={12} className="panel-bg">
                    <Typography component="h3" className="panel-head">
                        Ano atual - Médias e Acumulado
                    </Typography>

                    <Grid container={true} spacing={16}>
                        <Grid item={true} xs={3} sm={3}>
                            <MarketCoverPrice />
                        </Grid>

                        <Grid item={true} xs={3} sm={3}>
                            <MarketAveragePrice />
                        </Grid>

                        <Grid item={true} xs={3} sm={3}>
                            <MarketPriceAverageTicket />
                        </Grid>

                        <Grid item={true} xs={3} sm={3}>
                            <MarketPriceCoupon />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item={true} xs={12} sm={12}>
                    <MarketPriceAverageTicketEvolution title="Evolução Ticket Médio - Últimos 12 meses" type="12meses" />
                </Grid>

                <Grid item={true} xs={12} sm={12}>
                    <MarketPriceAverageTicketEvolution title="Evolução Ticket Médio - Últimos 30 dias" type="30dias" />
                </Grid>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/market/general/price/MarketPrice.tsx